import { useMutation } from '@tanstack/react-query'
import {
  createContact,
  type CreateContactParams,
} from '../services/createContact.service'

export function useContactMutation() {
  return useMutation({
    mutationFn: (data: CreateContactParams) => createContact(data),
  })
}
